import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/cookieConsent.css'; // ✅ Corrected path

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  return showBanner ? (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent banner">
      <div className="cookie-content">
        <p>
          We use cookies to improve your experience. By using our site, you agree to our{' '}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
        <div className="cookie-buttons">
          <button onClick={handleAccept}>Accept All</button>
          <Link to="/privacy" className="learn-more">Learn More</Link>
        </div>
      </div>
    </div>
  ) : null;
};

export default CookieConsent;
